export default {
  ocr: [],
}